import { Alteracao, DadosPendenciaMovida } from "./types";
import type { Email } from "../DemandaCriada/types";
import { parseJsonSafely } from "../../../../../../../utility/jsonUtils";
import { mapearEmail } from "../../../../../../../utility/historicoLogUtils";
import { getStatusLabelStatusKanban, getResultadoLabelPendencia } from "../../../../../../../utility/statusPendenciaKanban";

export const mapearAlteracoes = (logPendencia: any, dadosExtra: any): Alteracao[] => {
    if (!logPendencia || !logPendencia.dados_antes || !logPendencia.dados_depois) {
        return [];
    }

    const dadosAntes = parseJsonSafely(logPendencia.dados_antes);
    const dadosDepois = parseJsonSafely(logPendencia.dados_depois);
    const extra = parseJsonSafely(dadosExtra);

    const alteracoes: Alteracao[] = [];

    if (extra?.status_anterior && extra?.status_novo) {
        alteracoes.push({
            campo: 'Status',
            antes: getStatusLabelStatusKanban(extra.status_anterior),
            depois: getStatusLabelStatusKanban(extra.status_novo)
        });
    } else if (dadosAntes?.status_kanban && dadosDepois?.status_kanban) {
        alteracoes.push({
            campo: 'Status',
            antes: getStatusLabelStatusKanban(dadosAntes.status_kanban),
            depois: getStatusLabelStatusKanban(dadosDepois.status_kanban)
        });
    }

    const resultadoAntes = dadosAntes?.resultado ?? null;
    const resultadoDepois = dadosDepois?.resultado ?? null;
    if (resultadoAntes !== resultadoDepois) {
        alteracoes.push({
            campo: 'Resultado',
            antes: getResultadoLabelPendencia(resultadoAntes),
            depois: getResultadoLabelPendencia(resultadoDepois)
        });
    }

    const respostaAntes = dadosAntes?.resposta ?? null;
    const respostaDepois = dadosDepois?.resposta ?? null;
    if (respostaAntes !== respostaDepois) {
        alteracoes.push({
            campo: 'Resposta',
            antes: respostaAntes || '—',
            depois: respostaDepois || '—'
        });
    }

    return alteracoes;
};

export const processarDadosPendenciaMovida = (logs: any[]): DadosPendenciaMovida => {
    const logPendencia = logs.find((log: any) => log.entidade_nome === 'pendencia');
    
    if (!logPendencia) {
        return {
            alteracoes: [],
            email: null,
            idPendencia: undefined
        };
    }

    const dadosExtra = parseJsonSafely(logPendencia.dados_extra);
    const alteracoes = mapearAlteracoes(logPendencia, dadosExtra);
    const email = mapearEmail(logs);

    return {
        alteracoes,
        email,
        idPendencia: logPendencia.entidade_id
    };
};

